import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value && _vm.value.visibilidade
    ? _c(
        VTimelineItem,
        {
          attrs: { color: _vm.cor, icon: _vm.value.icone, dark: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "icon",
                fn: function () {
                  return [
                    _vm.prazo && _vm.value.exibeStatus
                      ? _c(
                          VBadge,
                          {
                            attrs: { color: _vm.prazo.cor, right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "badge",
                                  fn: function () {
                                    return [
                                      _vm.prazo && _vm.value.exibeStatus
                                        ? _c(VIcon, [
                                            _vm._v(_vm._s(_vm.prazo.icone)),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3161569263
                            ),
                          },
                          [_c(VIcon, [_vm._v(_vm._s(_vm.value.icone))])],
                          1
                        )
                      : _c(VIcon, [_vm._v(_vm._s(_vm.value.icone))]),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            986809489
          ),
        },
        [
          _c(
            VCard,
            {
              staticClass: "elevation-2",
              attrs: {
                color: _vm.cor,
                loading:
                  typeof _vm.value.progresso === "number" &&
                  _vm.prazo &&
                  _vm.prazo.status !== "FUTURO",
                dark: "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "progress",
                    fn: function () {
                      return [
                        _c(VProgressLinear, {
                          attrs: {
                            value: _vm.value.progresso,
                            color: _vm.corProgress,
                            "background-color": "grey lighten-2",
                            height: "22",
                            rounded: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "grey--text text--darken-3",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("decimal")(
                                              _vm.value.progresso
                                            )
                                          ) + "% concluído"
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1639423276
                          ),
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2707457318
              ),
            },
            [
              _c(
                VCardTitle,
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "body-1 font-weight-bold text-sm-h6 text-break mr-8",
                    },
                    [_vm._v(_vm._s(_vm.value.titulo))]
                  ),
                  _c(VSpacer),
                  _c(
                    VTooltip,
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      attrs: {
                                        text: "",
                                        small: "",
                                        icon: "",
                                        absolute: "",
                                        right: "",
                                        top: "",
                                      },
                                      on: { click: _vm.toogleExpand },
                                    },
                                    on
                                  ),
                                  [
                                    _c(VIcon, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.expand
                                            ? "expand_less"
                                            : "expand_more"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3280576681
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Clique no botão para " +
                            _vm._s(_vm.expand ? "ocultar" : "expandir")
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm.prazo
                ? _c(
                    VCardSubtitle,
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.expand,
                          expression: "expand",
                        },
                      ],
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.prazo.periodo))]),
                      _c(VSpacer),
                      _vm.value.aviso
                        ? _c(
                            VTooltip,
                            {
                              attrs: { "max-width": "500", top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _vm.value.aviso.icone
                                          ? _c(
                                              VBadge,
                                              {
                                                attrs: {
                                                  color: `${_vm.value.aviso.cor} lighten-2`,
                                                  overlap: "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "badge",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                color: "black",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.value
                                                                    .aviso.icone
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  VChip,
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        label: "",
                                                        small: "",
                                                        outlined: "",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.value.aviso.texto
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              VChip,
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    label: "",
                                                    small: "",
                                                    outlined: "",
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.value.aviso.texto
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2209605194
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.value.aviso.descricao
                                      ? _vm.value.aviso.descricao
                                      : _vm.value.aviso.texto
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VCardText,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.expand,
                      expression: "expand",
                    },
                  ],
                  class: _vm.$vuetify.theme.dark
                    ? "contrast"
                    : "white text--primary",
                },
                _vm._l(_vm.value.textos, function (texto, index) {
                  return _c(
                    "p",
                    { key: index, staticClass: "text-justify pt-4" },
                    [_vm._v(_vm._s(texto))]
                  )
                }),
                0
              ),
              _c(
                VCardActions,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.expand,
                      expression: "expand",
                    },
                  ],
                  class: _vm.$vuetify.theme.dark
                    ? "contrast pa-2"
                    : "white text--primary pa-2",
                },
                [
                  _vm.prazo && _vm.value.exibeStatus
                    ? _c(
                        VChip,
                        {
                          staticClass: "mr-1 pa-1",
                          attrs: {
                            color: _vm.prazo.cor,
                            outlined: "",
                            small: "",
                          },
                        },
                        [
                          _c(VIcon, { staticClass: "mr-1" }, [
                            _vm._v(_vm._s(_vm.prazo.icone)),
                          ]),
                          _vm._v(" " + _vm._s(_vm.prazo.descricao) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(VSpacer),
                  !_vm.prazo || (_vm.prazo && _vm.prazo.status !== "FUTURO")
                    ? _c(
                        VBtn,
                        {
                          attrs: { color: _vm.cor, outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.to(_vm.value.link)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.prazo &&
                                  _vm.prazo.status === "FINALIZADO" &&
                                  _vm.value.exibeStatus
                                  ? "visualizar"
                                  : "Acessar"
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }